export interface ModelOption {
  /** Qualified `provider:model` reference — what the server expects back in selectedModel. */
  id: string
  provider: string
  providerLabel: string
  label: string
}

/** Every model the server can run for this writer, across all live providers. */
export async function listModels(): Promise<ModelOption[]> {
  try {
    const data = await window.api.models.list()
    if (data && Array.isArray(data.data)) {
      return data.data
        .filter((m: any) => m && typeof m.id === 'string')
        .map((m: any) => ({
          id: m.id,
          provider: String(m.provider || ''),
          providerLabel: String(m.providerLabel || ''),
          label: String(m.label || m.id)
        }))
    }
    return []
  } catch (err) {
    console.error('Failed to list models:', err)
    throw err
  }
}
